import * as React from "react";
export function SvgSchemaViewerDateCalcContinuous(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={17} {...props}>
      <path
        d="M16 4h-2V3h-1v1h-2V3h-1v1H8c-.5 0-1 .5-1 1v7c0 .5.5 1 1 1h8c.5 0 1-.5 1-1V5c0-.5-.5-1-1-1zm0 8H8V8h8v4zm0-5H8V5h2v1h1V5h2v1h1V5h2v2zM3 9h3v1H3zM3 7h3v1H3z"
        fill="#47a67f"
      />
    </svg>
  );
}
